const module = {
  routes: [
    {
      path: '/command-templates',
      component: () => import('@/modules/commandTemplates/pages/index.vue'),
      meta: {
        layout: 'default',
        requiresAuth: true
      }
    }
  ]
};

export default module;
